import { v4 as uuidv4 } from 'uuid';
export class VendorModel {
    constructor() {
        this.id = uuidv4();
        this.vendorName = null;
        this.contactPerson = null;
        this.contactNumber = null;
    }
}
export default class Vendor extends VendorModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
